//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {apiUrl, apiParams} from '@/const/const'
import MyBtnReturn from '@/components/subComponents/MyBtnReturn'

export default {
    name: 'VehicletrackingResult',
    components: {
        MyBtnReturn
    },
    data() {
        return {
            tableData: [],
            // newData: [
            //   {
            //     c_drive_num_hk: '090',
            //     truck_no: '粤Ajk232',
            //     truck_company: '远集拖车',
            //     c_phone: '13515646848',
            //     zxhdz: '',
            //     time: '0',
            //     truck_status: 0,
            //     c_truck_tracing_status: 0, // 车辆状态
            //     // isShowBtn: false, // 这个不是后台传的，而是前端添加
            //   },
            // ],// 假数据，后续要注释
            tracingStatusList: [
                {
                    key: 0,
                    value: '营运'
                },
                {
                    key: 1,
                    value: '待安排'
                },
                {
                    key: 2,
                    value: '维修'
                },
                {
                    key: 3,
                    value: '交通事故'
                },
                {
                    key: 4,
                    value: '违章'
                },
            ],
            isShowTable: true,
            isShowLoading: false,
            originSelectedStatus: [],
            canFetch: true, // true代表能继续发送请求，控制getMoreData方法的
            canUpdate: true, // true代表能继续发送请求，控制updateState方法的
            pageSize: 5, // 告知后台一次传回几条表格数据，默认5
            pageNo: 1, // 当前为第几页数据，要累加
            totalCount: 0, // 表格数据总条数，后台返回，计算总页数totalPages
            totalPages: 2, // 总页数，初始化必须比pageNo大
            isNoData: false, // false代表有数据
            url: apiUrl.vehicleTemplate,
            updateUrl: apiUrl.updateVehicle,
        }
    },
    created() {
        document.title = '车辆跟踪';
        this.onScrollBottom()
    },
    methods: {
        getMoreData(url, data) {
            // 还要先判断到了最后一页了没
            if (this.pageNo > this.totalPages) {
                this.canFetch = true; // 要恢复可以获取状态，可继续提示暂无更多数据
                this.isShowLoading = false;
                this.$vux.toast.show({
                    text: '暂无更多数据！',
                    time: 2000,
                    position: 'middle',
                    type: 'text'
                });
                return
            }
            // 调用接口获取数据
            this.requestApi({
                url: url,
                data: data,
            }, (resultData) => {
                let dataObj = resultData.data.page;
                let resultArr = dataObj.result || []; // 防止后台返回null
                if (this.pageNo === 1 && resultArr.length === 0) {
                    // 如果根本没有数据
                    this.isShowTable = false;
                    this.isNoData = true;
                    this.isShowLoading = false;
                    return
                }
                resultArr.forEach((item) => {
                    // 为了控制保存按钮，要先给返回的数据添加一个属性isShowBtn
                    item.isShowBtn = false;
                    this.tableData.push(item);
                    // 为了让selector的value恢复到初始值，要先保存刚请求回来的
                    this.originSelectedStatus.push(item.c_truck_tracing_status)
                }); // 表格数据是放在result中
                this.totalCount = dataObj.totalCount;
                this.totalPages = dataObj.totalPages;
                this.pageNo++;
                this.$nextTick(() => {
                    this.$refs.scrollerBottom.reset()
                }) // 要重置scroller组件
            }, (error) => {
                this.isShowLoading = false;
                this.canFetch = true;
                if (error) {
                    console.error(error);
                }
            })
        },
        onScrollBottom() {
            this.isShowLoading = true;
            let query = this.$route.query;
            let data = {
                begin: query.loadDate,
                end: query.unloadingDate,
                truck_no: query.truck_no,
                is_self: query.is_self,
                pageSize: this.pageSize, // 告知后台一次传回几条表格数据，默认5
                pageNo: this.pageNo, // 当前为第几页数据，要累加
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
            };
            if (!this.canFetch) {
            } else {
                this.canFetch = false;
                this.getMoreData(this.url, data)
            }
        },
        changeNative(e, index) {
            // 不用vux的on-change，使用原生的change事件就不会首次渲染触发，而且后台可能会传默认选项，因此也无法判断用户有没选择；
            // 不过原生的change事件中无法正常获取到v-model绑定的值，因此只能使用e.target.value获取了
            // 现在要控制对应的保存按钮，两种方式：
            // 1、为tableData加一个控制按钮属性，每次修改都找到对应数据，修改这个控制的属性；
            // 2、直接获取到该按钮的dom，然后控制显示状态
            this.tableData[index].isShowBtn = true
        },
        updateState(index) {
            // 点击保存按钮后，调用接口保存，参数有：c_drive_num_hk、truck_no、被选中的c_truck_tracing_status
            let data = {
                c_drive_num_hk: this.tableData[index].c_drive_num_hk,
                truck_no: this.tableData[index].truck_no,
                state: this.tableData[index].c_truck_tracing_status,
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
            };
            // 调用接口进行修改
            this.canUpdate = false;
            this.requestApi({
                url: this.updateUrl,
                data: data
            }, (resultData) => {
                // 没看懂后台会返回什么，先当做到这一步就是更新成功吧
                // 接口调用成功后，要隐藏按钮，还可以给个成功toast
                this.$vux.toast.show({
                    text: '更新成功',
                    type: 'success',
                });
                this.tableData[index].isShowBtn = false;
                // this.$set(this.tableData[index],'isShowBtn',false)
                // 保存成功的话，要重置下originSelectedStatus里的数据
                this.originSelectedStatus[index] = this.tableData[index].c_truck_tracing_status
            }, (error) => {
                this.canUpdate = true;
                console.error(error);
            })
        },
        handleCancel(index) {
            // 点击取消按钮后，要重置selector的默认值
            this.tableData[index].c_truck_tracing_status = this.originSelectedStatus[index];
            this.tableData[index].isShowBtn = false // 隐藏按钮
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/yewu/vehicletracking/VehicletrackingResult.vue